// src/AppRoutes.js
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import App from './App';
import NabiHealth from "./NabiHealth";
import NabiStore from "./NabiStore";
import NabiTraining from "./nabi_training";
import Blogs from "./Blogs";
import About from "./About";
import TherapistPage from "./therapist";
import VerifyEmail from "./VerifyEmail";
import UserProfile from "./UserProfile";
import TherapistDashboard from "./TherapistDashboard";
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";
import ShippingreturnPage from "./Shippingreturnpage";
import Careers from "./Careers";
import SelfReflection from "./selfreflection/selfreflection"
import AdminDashboard from "./AdminDashboard";
import Reflection from "./reflection";
import MyReflectionBeforeClassify from "./selfreflection/myreflectionbeforeclassify";
import EmotionSelection from "./selfreflection/EmotionSelection";
import ReflectionForm from "./selfreflection/ReflectionForm";
import Events from "./events";
import EventRecap from "./EventRecap";
import VoiceStory from "./VoiceStory";
import { auth, db } from "./firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function AppRoutes() {

  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", message: "" });
  const [cvFile, setCvFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const storage = getStorage();

  const handleApply = async (e, formDataParam, cvFileParam) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("🟢 handleApply CALLED with:", { formDataParam, cvFileParam });

    setIsSubmitting(true);

    try {
      let cvUrl = "";

      if (cvFileParam) {
        const fileRef = ref(storage, `career_cvs/${Date.now()}_${cvFileParam.name}`);
        await uploadBytes(fileRef, cvFileParam);
        cvUrl = await getDownloadURL(fileRef);
      }

      await addDoc(collection(db, "career_applications"), {
        ...formDataParam,
        jobTitle: "Counseling Psychologist",
        cvUrl,
        timestamp: serverTimestamp()
      });

      await fetch("https://formspree.io/f/yashhemantshinde2005@gmail.com", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formDataParam),
      });

      alert("Application submitted successfully!");

      setFormData({ firstName: "", lastName: "", email: "", message: "" });
      setCvFile(null);

    } catch (error) {
      console.error("Submission error:", error);
      alert("Submission error: " + error.message);
    }

    setIsSubmitting(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* All routes with navbar and footer */}
        <Route element={<Layout />}>
          <Route path="/" element={<App />} />
          <Route path="/nabi-health" element={<NabiHealth />} />
          <Route path="/store" element={<NabiStore />} />
          <Route path="/store/checkout" element={<NabiStore initialView="checkout" />} />
          <Route path="/training" element={<NabiTraining />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/voice-story" element={<VoiceStory />} />
          <Route path="/about" element={<About />} />
          <Route path="/reflection" element={<Reflection />} />
          <Route path="/myreflectionbeforeclassify" element={<MyReflectionBeforeClassify />} />
          <Route path="/emotion-selection" element={<EmotionSelection />} />
          <Route path="/reflection-form" element={<ReflectionForm />} />
          <Route path="/therapist" element={<TherapistPage />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/therapistdashboard" element={<TherapistDashboard />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/shipping-return" element={<ShippingreturnPage />} />
          <Route path="/selfreflection" element={<SelfReflection />} />
          <Route
            path="/careers"
            element={
              <Careers
                user={user}
                formData={formData}
                setFormData={setFormData}
                cvFile={cvFile}
                setCvFile={setCvFile}
                isSubmitting={isSubmitting}
                handleApply={handleApply}
              />
            }
          />
          <Route path="/events" element={<Events />} />
          <Route path="/recap/:eventId" element={<EventRecap />} />
        </Route>


        {/* Routes WITHOUT navbar and footer */}
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}